<template>

  <v-layout row wrap class="masterPatientData">
    <v-flex md3 class="sidebar">
      <aside>
        <span class="patient_profile">
          <h4>{{ptName}}</h4>
          <h5>{{ptAge}}/{{ptGender}}
            <span v-if='ptPlace === "undefined" || ptPlace ===  "null" '></span>
        <span v-else>, {{ptPlace}}</span>
        </h5>
        </span>
        <ul>
          <li class="active">
            <router-link :to="{name: 'vitalsPost', params: {status:`${vitalsStatus}`,appId: `${appId}`,ptId: `${ptId}`}}">Vitals</router-link>
          </li>
          <li style="color:gray">
            Investigation
        </li>
          <li>
            <router-link :to="{ name: 'prescription', params: {appId: `${appId}`,ptId: `${ptId}`} }">Prescriptions</router-link>
          </li>
          <!-- <li>
            <router-link :to="{ name: 'billing', params: {appId: `${appId}`,ptId: `${ptId}`}}">Billing</router-link>
          </li> -->
        </ul>
      </aside>
    </v-flex md3>
    <v-flex flex md9 pl-3>

      <!-- will show when {{vitalsNotStarted}} computed is true -->
      <el-form :model="customForm"
               ref="customForm"
               label-width="120px"
               class="demo-dynamic px-3 layout row wrap"
               label-position="top"
               id="vitalsFormPost"
               v-if='vitalsStatus === "not yet started"'>
        <div v-for="(question, index) in customForm.questions"
             :class="(question.web_name!=='bp' && question.web_name !== 'pefr') ? 'flex md6 el-input--custom' : 'bpContainer el-input--custom'">
          <!-- <div v-for="(question, index) in customForm.questions"
        :class="(question.web_name!=='bp' && question.web_name !== 'pefr') ? 'flex md6 el-input--custom' : ' bpContainer el-input--custom'"> -->
          <div class="d-flex vitalsAndImageContainer ss">
            <div :class="`vitalsImage vImg${index}`"
                 v-if='question.web_name !== "pefr" && question.web_name!=="bp" && question.web_name !== "b_s_a" && question.web_name !== "bmi"'>
              <img :src="`/static/vitals/${question.web_name}.png`" alt="">
            </div>
            <el-form-item v-if='question.web_name !== "pefr" && question.web_name!=="bp" && question.web_name !== "b_s_a" && question.web_name !== "bmi"'
                          :prop="'questions.'+index+'.value'"
                          class="flex md12 vitalsNotImage"
                          :rules="{
                whitespace: true,
                required: false,
                type: 'number',
                min: getStart(question.restrict_value_start),
                max: getEnd(question.restrict_value_end),
                message: `value must be between ${getStart(question.restrict_value_start)} and ${getEnd(question.restrict_value_end)}`,
                /* trigger: 'blur' */
                trigger: 'blur'
              }"
                          :key="question.key"
                          :label='question.sub_name + " " +"[" + question.unit + "]" + " " +"(" + (question.restrict_value_start ? question.restrict_value_start : "" ) + - + (question.restrict_value_end ? question.restrict_value_end : "" ) +  ")" '

                          clearValidate="clearValidate"
                          :ref='index'>

              <el-input class="questionHolder"
                        :name='question.id'
                        :alt='question.id'
                        v-model.number='question.value'
                        @focus="dOnFocus"
                        @blur="dOnChange($event,index)"></el-input>
            </el-form-item>
          </div>
          <!--  ****************************************************** -->
          <!--  if bsa -->
          <!--  ****************************************************** -->

          <div class="d-flex vitalsAndImageContainer flex" :id="'question'+index" v-if="question.web_name==='b_s_a'">
            <div :class="`vitalsImage vImg${index}`" v-if="question.web_name==='b_s_a'">
              <img :src="`/static/vitals/${question.web_name}.png`" alt="">
            </div>
            <el-form-item :key="question.key"
                          :prop="'questions.'+index+'.value'"
                          :label='question.sub_name + " " +"[" + question.unit + "]" + " " +"(" + (question.restrict_value_start ? question.restrict_value_start : "" ) + - + (question.restrict_value_end ? question.restrict_value_end : "" ) +  ")" '
                          class="  el-input--custom"
                          :rules="{
                            required: false,
                            type: 'number',
                            min: getStart(question.restrict_value_start),
                            max: getEnd(question.restrict_value_end),
                            message: `value must be between ${getStart(question.restrict_value_start)} and ${getEnd(question.restrict_value_end)}`
                            }">
              <el-input class="questionHolder"
                        type="number"
                        :name='question.id'
                        :alt='question.id'
                        @keyup="InputKeypress"
                        v-model.number='bsa'
                        v-if='question.web_name === "b_s_a"'
                        @focus="dOnFocus"
                        @blur="dOnChange($event, index)"
                        disabled></el-input>
            </el-form-item>
          </div>
          <!--  ****************************************************** -->
          <!--  if bmi -->
          <!--  ****************************************************** -->

          <div class="d-flex vitalsAndImageContainer flex" :id="'question'+index" v-if="question.web_name==='bmi'">
            <div :class="`vitalsImage vImg${index}`" v-if="question.web_name==='bmi'">
              <img :src="`/static/vitals/${question.web_name}.png`" alt="">
            </div>
            <el-form-item :key="question.key"
                          :prop="'questions.'+index+'.value'"
                          :label='question.sub_name + " " +"[" + question.unit + "]" + " " +"(" + (question.restrict_value_start ? question.restrict_value_start : "" ) + - + (question.restrict_value_end ? question.restrict_value_end : "" ) +  ")" '

                          class="  el-input--custom"
                          :rules="{
              required: false,
              type: 'number',
              min: getStart(question.restrict_value_start),
              max: getEnd(question.restrict_value_end),
              message: `value must be between ${getStart(question.restrict_value_start)} and ${getEnd(question.restrict_value_end)}`
              }">
              <el-input class="questionHolder"
                        type="number"
                        :name='question.id'
                        :alt='question.id'
                        @keyup="InputKeypress"
                        v-model.number='bmi'
                        v-if='question.web_name === "bmi"'
                        @focus="dOnFocus"
                        @blur="dOnChange($event, index)"
                        disabled></el-input>
            </el-form-item>
          </div>

          <!--  ****************************************************** -->
          <!--  if pefr -->
          <!--  ****************************************************** -->

          <div id="whateasd">
            <div class="vitalsAndImageContainer pefr" :id="'question'+index" v-if="question.web_name==='pefr'">
              <div :class="`vitalsImage vImg${index}`" v-if="question.web_name==='pefr'">
                <img :src="`/static/vitals/${question.web_name}.png`" alt="">
              </div>
              <el-form-item :key="question.key"
                            :prop="'questions.'+index+'.value'"
                            :label='question.sub_name + " " +"[" + question.unit + "]" + " " +"(" + (question.restrict_value_start ? question.restrict_value_start : "" ) + - + (question.restrict_value_end ? question.restrict_value_end : "" ) +  ")" '

                            class="pefrContainer el-input--custom"
                            :rules="{
                required: false,
                type: 'number',
                min: getStart(question.restrict_value_start),
                max: getEnd(question.restrict_value_end),
                message: `value must be between ${getStart(question.restrict_value_start)} and ${getEnd(question.restrict_value_end)}`
                }">
                <el-input class="questionHolder"
                          type="number"
                          :name='question.id'
                          :alt='question.id'
                          minlength=10
                          @keyup="InputKeypress"
                          maxlength=260
                          v-model.number='question.value'
                          v-if='question.web_name === "pefr"'
                          @focus="dOnFocus"
                          @blur="dOnChange($event, index)"></el-input>
              </el-form-item>
            </div>
          </div>
          <!--  ****************************************************** -->
          <!--  if bp -->
          <!--  ****************************************************** -->
          <div class="d-flex vitalsAndImageContainer">
            <div :class="`vitalsImage vImg${index}`" v-if="question.web_name==='bp'">
              <img :src="`/static/vitals/${question.web_name}.png`" alt="">
            </div>

            <div class=" flex " :id="'question'+index" v-if="question.web_name==='bp'">

              <el-form-item :key="question.key"
                            :prop="'questions.'+index+'.value'"
                            :label='question.sub_name + " " +"[" + question.unit + "]" + " " +"(" + (question.restrict_value_start ? question.restrict_value_start : "" ) + - + (question.restrict_value_end ? question.restrict_value_end : "" ) +  ")" '

                            class="bpContainer  el-input--custom"
                            :rules="{
            required: false,
            type: 'number',
            min: getStart(question.restrict_value_start),
            max: getEnd(question.restrict_value_end),
            message: `value must be between ${getStart(question.restrict_value_start)} and ${getEnd(question.restrict_value_end)}`
            }">
                <el-input class="questionHolder"
                          type="number"
                          :name='question.id'
                          :alt='question.id'
                          @keyup="InputKeypress"
                          v-model.number='question.value'
                          v-if='question.web_name === "bp"'
                          @focus="dOnFocus"
                          @blur="dOnChange($event, index)"></el-input>
              </el-form-item>
            </div>

          </div>
        </div>

        <!-- <button type="primary" @click.prevent="submitForm('customForm')">Submit</button> -->
        <!-- <button
        v-if='vitalsStatus === "not yet started"'
        class="el-button el-button--primary"
        type="primary" @click.prevent="submitForm('customForm')">Submit</button> -->

      </el-form>

      <div class="extendingBGcolor">
        <button v-if='vitalsStatus === "not yet started"' class="el-button el-button--primary" type="primary" @click.prevent="submitForm('customForm')">Submit</button>
      </div>
      <!-- will be show when {{vitalsNotStarted}} computed is false -->
      <el-form :model="customForm"
               ref="customForm"
               label-width="120px"
               class="demo-dynamic px-3 layout row wrap"
               label-position="top"
               id="vitalsFormUpdate"
               v-if='vitalsStatus !== "not yet started"'>
        <div v-for="(question, index) in customForm.questions"
             :class="(question.web_name!=='bp' && question.web_name !== 'pefr') ? 'flex md6 el-input--custom' : ' bpContainer el-input--custom'">

          <div class="d-flex vitalsAndImageContainer">
            <div :class="`vitalsImage vImg${index}`"
                 v-if='question.web_name !== "pefr" && question.web_name!=="bp" && question.web_name!=="b_s_a" && question.web_name!=="bmi"'>
              <img :src="`/static/vitals/${question.web_name}.png`" alt="">
            </div>
            <el-form-item v-if='question.web_name !== "pefr" && question.web_name!=="bp" && question.web_name!=="b_s_a" && question.web_name!=="bmi"'
                          :prop="'questions.'+index+ '.answers[0].answer'"
                          class="flex md12"
                          :rules="{
                whitespace: true,
              required: false,
              type: 'number',
              min: getStart(question.restrict_value_start),
              max: getEnd(question.restrict_value_end),
              message: `value must be between ${getStart(question.restrict_value_start)} and ${getEnd(question.restrict_value_end)}`,
              trigger: 'change'
              }"
                          :key="question.key"
                          :label='question.sub_name + " " +"[" + question.unit + "]" + " " +"(" + (question.restrict_value_start ? question.restrict_value_start : "" ) + - + (question.restrict_value_end ? question.restrict_value_end : "" ) +  ")" '>

              <el-input class="questionHolder"
                        type="number"
                        :alt='question.id'
                        :name='(question.answers[0].ans_id == null) ? 0 : question.answers[0].ans_id'
                        v-model.number='question.answers[0].answer'
                        @focus="dOnFocus"
                        @blur="dOnChange($event, index)"></el-input>

            </el-form-item>
          </div>

          <div class="d-flex vitalsAndImageContainer flex " :id="'question'+index" v-if="question.web_name==='b_s_a'">
            <div :class="`vitalsImage vImg${index}`" v-if="question.web_name==='b_s_a'">
              <img :src="`/static/vitals/${question.web_name}.png`" alt="">
            </div>
            <el-form-item :key="question.key"
                          :prop="'questions.'+index+ '.answers[0].answer'"
                          :label='question.sub_name + " " +"[" + question.unit + "]" + " " +"(" + (question.restrict_value_start ? question.restrict_value_start : "" ) + - + (question.restrict_value_end ? question.restrict_value_end : "" ) +  ")" '

                          class="  el-input--custom">
              <el-input class="questionHolder"
                        type="number"
                        :alt='question.id'
                        :name='(question.answers[0].ans_id == null) ? 0 : question.answers[0].ans_id'
                        @keyup="InputKeypress"
                        v-model.number='bsa'
                        @focus="dOnFocus"
                        @blur="dOnChange($event, index)"
                        disabled>
              </el-input>
            </el-form-item>
          </div>

          <div class="d-flex vitalsAndImageContainer flex" :id="'question'+index" v-if="question.web_name==='bmi'">
            <div :class="`vitalsImage vImg${index}`" v-if="question.web_name==='bmi'">
              <img :src="`/static/vitals/${question.web_name}.png`" alt="">
            </div>
            <el-form-item :key="question.key"
                          :prop="'questions.'+index+ '.answers[0].answer'"
                          :label='question.sub_name + " " +"[" + question.unit + "]" + " " +"(" + (question.restrict_value_start ? question.restrict_value_start : "" ) + - + (question.restrict_value_end ? question.restrict_value_end : "" ) +  ")" '

                          class="  el-input--custom">
              <el-input class="questionHolder"
                        type="number"
                        :alt='question.id'
                        :name='(question.answers[0].ans_id == null) ? 0 : question.answers[0].ans_id'
                        @keyup="InputKeypress"
                        v-model.number='bmi'
                        @focus="dOnFocus"
                        @blur="dOnChange($event, index)"
                        disabled>
              </el-input>
            </el-form-item>
          </div>

          <div class="d-flex vitalsAndImageContainer" :id="'question'+index" v-if="question.web_name==='bp'">
            <div :class="`vitalsImage vImg${index}`" v-if="question.web_name==='bp'">
              <img :src="`/static/vitals/${question.web_name}.png`" alt="">
            </div>
            <el-form-item :key="question.key"
                          :prop="'questions.'+index+ '.answers[0].answer'"
                          :label='question.sub_name + " " +"[" + question.unit + "]" + " " +"(" + (question.restrict_value_start ? question.restrict_value_start : "" ) + - + (question.restrict_value_end ? question.restrict_value_end : "" ) +  ")" '

                          class="bpContainer  el-input--custom"
                          :rules="{
              whitespace: true,
            required: false,
            type: 'number',
            min: getStart(question.restrict_value_start),
            max: getEnd(question.restrict_value_end),
            message: `value must be between ${getStart(question.restrict_value_start)} and ${getEnd(question.restrict_value_end)}`,
            trigger: 'change'
            }">
              <el-input class="questionHolder"
                        type="number"
                        :alt='question.id'
                        :name='(question.answers[0].ans_id == null) ? 0 : question.answers[0].ans_id'
                        @keyup="InputKeypress"
                        v-model.number='question.answers[0].answer'
                        @focus="dOnFocus"
                        @blur="dOnChange($event, index)">
              </el-input>
            </el-form-item>
          </div>

          <div class="d-flex vitalsAndImageContainer flex md6" :id="'question'+index" v-if="question.web_name==='pefr'">
            <!-- <div
          :class="`vitalsImage vImg${index}`"
          v-if="question.web_name==='pefr'">
            <img :src="`/static/vitals/${question.web_name}.png`" alt="">
          </div> -->
            <el-form-item :key="question.key"
                          :prop="'questions.'+index+ '.answers[0].answer'"
                          :label='question.sub_name + " " +"[" + question.unit + "]" + " " +"(" + (question.restrict_value_start ? question.restrict_value_start : "" ) + - + (question.restrict_value_end ? question.restrict_value_end : "" ) +  ")" '

                          class="flex el-input--custom"
                          :rules="{
              whitespace: true,
            required: false,
            type: 'number',
            min: getStart(question.restrict_value_start),
            max: getEnd(question.restrict_value_end),
            message: `value must be between ${getStart(question.restrict_value_start)} and ${getEnd(question.restrict_value_end)}`,
            trigger: 'change'
            }">
              <el-input class="questionHolder"
                        type="number"
                        :alt='question.id'
                        :name='(question.answers[0].ans_id == null) ? 0 : question.answers[0].ans_id'
                        minlength=10
                        @keyup="InputKeypress"
                        maxlength=260
                        v-model.number='question.answers[0].answer'
                        @focus="dOnFocus"
                        @blur="dOnChange($event, index)"></el-input>
            </el-form-item>
          </div>

        </div>
        <!-- <button
        v-if='vitalsStatus !== "not yet started"'
        class="el-button el-button--primary"
        type="primary" @click.prevent="updateForm('customForm')">Update</button> -->
      </el-form>

      <div class="extendingBGcolor">
        <button v-if='vitalsStatus !== "not yet started"' class="el-button el-button--primary" type="primary" @click.prevent="updateForm('customForm')">Update</button>

      </div>

    </v-flex md9>
    <!-- <v-snackbar :timeout="timeout" :color="snackbarColor" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
      {{ snackbarText }}
      <v-btn dark flat @click.native="snackbar = false">Close</v-btn>
    </v-snackbar> -->
  </v-layout>

</template>

<script>

  import { api } from '../api.js'
  import { mapState } from 'vuex'
  import { store } from '../store'
  import { axios, get, post } from 'axios'
  import jquery from 'jquery'
  import _ from 'lodash'
  import Cleave from 'vue-cleave'
  import { Notification } from 'element-ui'
  import index from '../router/index.js'
  import ibmi from '../../static/vitals/bmi.png'
  import ibp from '../../static/vitals/bp.png'
  export default {
    name: 'vitalsPost',
    components: {
      Cleave
    },
    data() {
      return {
        dynamicValidateForm: {
          field: ''
        },
        customForm: {
          questions: []
        },
        unmodifiedQuestion: [],
        customFormUpdate: [],
        values: {},
        valid: false,
        snackbar: false,
        snackbarColor: '',
        mode: '',
        timeout: 6000,
        snackbarTitle: '',
        snackbarText: '',
        bp1: '',
        bp2: '',
        pefr: '',
        bpHigh: '',
        bpLow: '',
        heightValue: null,
        weightValue: null,
        bsaValue: null,
        images: {
          ibmi,
          ibp
        }
      }
    },

    // mounted() {
    //   // get list of questions
    //   get(
    //     api + `/categories/1/questions?person_id=${this.$route.params.ptId}`
    //   ).then(res => {
    //     console.log(this.$route.params.status);

    //     const listOfQues = res.data.questions;
    //     // listOfQues.forEach(question => this.$set(this.values, question.id, ''))
    //     this.customForm.questions = listOfQues;
    //   });
    // },
    mounted() {
      // get list of questions
      // get(api + `/categories/1/questions?person_id=${this.$route.params.ptId}`)
       get(api + `/v4/getQuestions?category_id=1&appointment_id=${this.$route.params.appId}`)
        .then(res => {
          const respQuestions = res.data.question_list.questions
          this.unmodifiedQuestion = respQuestions
          const questions = respQuestions
            .filter(q => q.name !== 'BP')
            .filter(q => q.name !== 'PEFR')
            .map(item => {
              let question = item
              if (!item.answers.length) {
                question.answers.push({
                  ans_id: null,
                  answer: null
                })
              }
              return question
            })

          const dummyQuestionsForRendering = []

          respQuestions.map(question => {
            const item = {
              ...question
            }
            let splittedAnswer = question.name === 'BP' ? [0, 0] : [0, 0, 0]
            if (question.answers.length && (question.name === 'BP' || question.name === 'PEFR')) {
              splittedAnswer = question.answers[0].answer.split('-')
              splittedAnswer.forEach((x, index) => {
                dummyQuestionsForRendering.push({
                  ...question,
                  ...{
                    answers: [
                      {
                        ans_id: question.answers[0].ans_id,
                        answer: x
                      }
                    ]
                  }
                })
              })
            } else if (question.name === 'BP') {
              dummyQuestionsForRendering.push({
                ...question,
                ...{
                  answers: [
                    {
                      ans_id: null,
                      answer: 0
                    }
                  ]
                }
              })
              dummyQuestionsForRendering.push({
                ...question,
                ...{
                  answers: [
                    {
                      ans_id: null,
                      answer: 0
                    }
                  ]
                }
              })
            } else if (question.name === 'PEFR') {
              dummyQuestionsForRendering.push({
                ...question,
                ...{
                  answers: [
                    {
                      ans_id: null,
                      answer: 0
                    }
                  ]
                }
              })
              dummyQuestionsForRendering.push({
                ...question,
                ...{
                  answers: [
                    {
                      ans_id: null,
                      answer: 0
                    }
                  ]
                }
              })
              dummyQuestionsForRendering.push({
                ...question,
                ...{
                  answers: [
                    {
                      ans_id: null,
                      answer: 0
                    }
                  ]
                }
              })
            }
          })

          const concatt = questions.concat(dummyQuestionsForRendering)
          // const sortedd = _.sortBy(concatt, ['tags[0].position'])
          this.customForm.questions = concatt
          return res.data.question_list.questions
        })
        .then(questions => {
          const qForHWvalues = questions
          const heightFiltered = _.filter(qForHWvalues, {
            web_name: 'height'
          })
          const weightFiltered = _.filter(qForHWvalues, {
            web_name: 'weight'
          })
          // console.log(weightFiltered[0].answers[0].answer);
          if (heightFiltered[0].answers.length && weightFiltered[0].answers.length) {
            this.heightValue = heightFiltered[0].answers[0].answer
            this.weightValue = weightFiltered[0].answers[0].answer
          } else {
            this.heightValue = null
            this.weightValue = null
          }
        })
    },
    methods: {
      getStart(data){
        if(data != null){
          return data
        }
        else{
          return ""
        }
      },
      getEnd(data){
       if(data != null){
          return data
        }
        else{
          return ""
        }
      },
      InputKeypress(e) {
        console.log(e)
      },

      submitForm(customForm) {
        this.submit()
        // this.$refs[customForm].validate(valid => {
        //   if (valid) {
        //     this.submit()
        //   } else {
        //     console.log("error submit!!");
        //     return false;
        //   }
        // });
      },
      updateForm(customForm) {
        this.update()
        // this.$refs[customForm].validate(valid => {
        //   if (valid) {
        //
        //   } else {
        //     console.log("error submit!!");
        //     return false;
        //   }
        // });
      },
      validate() {
        this.$refs.form.validate()
      },
      submit() {
        // vitalsPostForm
        var elem = document.getElementById('vitalsFormPost').elements
        const answers = []
        const bp = []
        const pefr = []

        for (var i = 0; i < elem.length; i++) {
          if (elem[i].name === '132') {
            bp.push(elem[i].value)
            console.log(bp)
          } else if (elem[i].name === '164') {
            pefr.push(elem[i].value)
            console.log(pefr)
          } else {
            answers.push({
              qid: _.toNumber(elem[i].name),
              answers: elem[i].value
            })
          }

          if (bp.length === 2 && bp[0].length && bp[1].length) {
            answers.push({
              qid: 132, // bp
              answers: bp.join('-')
            })
          }

          if (pefr.length === 3 && pefr[0].length && pefr[1].length && pefr[2].length) {
            answers.push({
              qid: 164, // pefr
              answers: pefr.join('-')
            })
          }
        }
        const uniq = _.uniqBy(answers, 'qid').filter(x => x.answers.length)

        console.log(uniq)

        let answerPostDefaults = {
          category_id: '1',
          appointment_id: `${this.$route.params.appId}`,
          patient_answers: uniq
        }
        console.group('answerPostDefaults')
        console.log(answerPostDefaults)
        console.groupEnd('answerPostDefaults')
        if(!answerPostDefaults.patient_answers.length) {
          Notification({
              title: 'No values entered for Vitals',
              message: 'Please enter values for vitals before clicking on the submit button.',
              type: 'error'
            })
          return;
        }

        post(api + `/post_answers`, answerPostDefaults).then(res => {
          console.log(res.data.message)
          if (res.data.status === true) {
            this.snackbarTitle = 'Success'
            this.snackbarText = ''
            Notification({
              title: 'Success',
              message: 'Vitals added',
              type: 'success'
            })
            localStorage.setItem('vitalsStatus', 'finished')
            // this.$router.push('/dashboard')
                      let clinic_id = localStorage.getItem("clinic_id");
          let doctor_id = localStorage.getItem("doctor_id");
          this.$router.push("/dashboard/" + clinic_id + "/" + doctor_id);
          } else {
            Notification({
              title: 'Error',
              message: 'Something went wrong',
              type: 'error'
            })
          }
        })
      },

      update() {
        // vitalsUpdateForm
        var elem = document.getElementById('vitalsFormUpdate').elements
        const answers = []
        const bp = []
        const pefr = []

        for (var i = 0; i < elem.length; i++) {
          if (elem[i].alt == 132) {
            bp.push(elem[i].value)
          } else if (elem[i].alt == 164) {
            pefr.push(elem[i].value)
          } else {
            if (_.isEmpty(elem[i].value)) {
              if (elem[i].name !== '0') {
                answers.push({
                  person_ans_id: _.toNumber(elem[i].name),
                  answers: [
                    {
                      ans_id: _.toNumber(elem[i].name),
                      answer: elem[i].value,
                      is_active: 0
                    }
                  ]
                })
              } else {
                answers.push({
                  q_type: 'number',
                  qid: _.toNumber(elem[i].alt),
                  answers: [
                    {
                      answer: elem[i].value,
                      is_active: 0
                    }
                  ]
                })
              }
            } else {
              if (elem[i].name !== '0') {
                answers.push({
                  person_ans_id: _.toNumber(elem[i].name),
                  answers: [
                    {
                      ans_id: _.toNumber(elem[i].name),
                      answer: elem[i].value,
                      is_active: 1
                    }
                  ]
                })
              } else {
                answers.push({
                  q_type: 'number',
                  qid: _.toNumber(elem[i].alt),
                  answers: [
                    {
                      answer: elem[i].value,
                      is_active: 1
                    }
                  ]
                })
              }
            }
          }

          if (bp.length === 2 && elem[i].alt == 132) {
            if (_.isEmpty(elem[i].value)) {
              if (elem[i].name !== '0') {
                answers.push({
                  person_ans_id: _.toNumber(elem[i].name), // bp
                  answers: [
                    {
                      ans_id: _.toNumber(elem[i].name),
                      answer: bp.join('-'),
                      is_active: 0
                    }
                  ]
                })
              } else {
                answers.push({
                  q_type: 'number',
                  qid: _.toNumber(elem[i].alt),
                  answers: [
                    {
                      answer: bp.join('-'),
                      is_active: 0
                    }
                  ]
                })
              }
            } else {
              if (elem[i].name !== '0') {
                answers.push({
                  person_ans_id: _.toNumber(elem[i].name), // bp
                  answers: [
                    {
                      ans_id: _.toNumber(elem[i].name),
                      answer: bp.join('-'),
                      is_active: 1
                    }
                  ]
                })
              } else {
                answers.push({
                  q_type: 'number',
                  qid: _.toNumber(elem[i].alt),
                  answers: [
                    {
                      answer: bp.join('-'),
                      is_active: 1
                    }
                  ]
                })
              }
            }
          } else if (pefr.length === 3 && elem[i].alt == 164) {
            if (_.isEmpty(elem[i].value)) {
              if (elem[i].name !== '0') {
                answers.push({
                  person_ans_id: _.toNumber(elem[i].name), // pefr
                  answers: [
                    {
                      ans_id: _.toNumber(elem[i].name),
                      answer: pefr.join('-'),
                      is_active: 0
                    }
                  ]
                })
              } else {
                answers.push({
                  q_type: 'number',
                  qid: _.toNumber(elem[i].alt),
                  answers: [
                    {
                      answer: pefr.join('-'),
                      is_active: 0
                    }
                  ]
                })
              }
            } else {
              if (elem[i].name !== '0') {
                answers.push({
                  person_ans_id: _.toNumber(elem[i].name), // pefr
                  answers: [
                    {
                      ans_id: _.toNumber(elem[i].name),
                      answer: pefr.join('-'),
                      is_active: 1
                    }
                  ]
                })
              } else {
                answers.push({
                  q_type: 'number',
                  qid: _.toNumber(elem[i].alt),
                  answers: [
                    {
                      answer: pefr.join('-'),
                      is_active: 1
                    }
                  ]
                })
              }
            }
          }
        }

        // #1
        // filter bp and pefr values if 0-0 or 0-0-0 respectively from [answers]
        const bpFiltered = _.remove(answers, function(o) {
          return o.answers[0].answer === '0-0'
        })
        const pefrFiltered = _.remove(answers, function(o) {
          return o.answers[0].answer === '0-0-0'
        })

        // #2
        // partition the array based on whether it already had an answer
        const sswowow = _.partition(answers, ['q_type', 'number'])

        // #3
        // assign vars to the partitioned arrays
        const [r, s] = sswowow

        // #4
        // fetch only unique values by qid & person_ans_id
        // coz bp and pefr has multiple elements
        const uniqByQId = _.uniqBy(r, 'qid')
        const uniqByPersonId = _.uniqBy(s, 'person_ans_id')

        // #5
        // concat partitioned and uniq arrays for payload
        const concatAnswers = _.concat(uniqByQId, uniqByPersonId)

        // console.log(concatAnswers);

        // #6
        // prepare for launch
        let answerUpdateDefaults = {
          category_id: '1',
          appointment_id: `${this.$route.params.appId}`,
          patient_answers: concatAnswers
        }

        console.log('concatAnswers')
        console.log(concatAnswers)

        // #7
        // launch 🚀
        post(api + `/ans_update`, answerUpdateDefaults).then(res => {
          if (res.data.status === true) {
            Notification({
              title: 'Success',
              message: 'Vitals updated',
              type: 'success'
            })
            // this.$router.push('/dashboard')
                      let clinic_id = localStorage.getItem("clinic_id");
          let doctor_id = localStorage.getItem("doctor_id");
          this.$router.push("/dashboard/" + clinic_id + "/" + doctor_id);
          } else {
            Notification({
              title: 'Error',
              message: 'Something went wrong',
              type: 'error'
            })
          }
        })
      },
      dOnFocus() {
        $('input').on('keydown', function(e) {
          if (e.keyCode == 38 || e.keyCode == 40) {
            e.preventDefault()
          }
        })
      },
      clearValidate() {
        // console.log(event);
      },
      dOnChange(event, index) {
        if (event.srcElement.alt === '60') {
          this.heightValue = event.srcElement.value
        } else if (event.srcElement.alt === '61') {
          this.weightValue = event.srcElement.value
        } else if (event.srcElement.value === '') {
          // this.$refs.customForm.$children[index].resetField()
          this.$refs.customForm.$children[index].clearValidate()
        }
      }
    },
    computed: {
      vitalsNotStarted: function() {
        if (this.$route.params.status !== 'not yet started') {
          return true
        }
      },
      vitalsStatus: function() {
        const vitalsStatus = localStorage.getItem('vitalsStatus')
        return vitalsStatus
      },
      appId: function() {
        if (this.$route.params.appId !== null) {
          return this.$route.params.appId
        }
      },
      ptId: function() {
        if (this.$route.params.ptId !== null) {
          return this.$route.params.ptId
        }
      },
      ptName: function() {
        return localStorage.getItem('ptName')
      },
      ptAge: function() {
        return localStorage.getItem('ptAge')
      },
      ptGender: function() {
        return localStorage.getItem('ptGender')
      },
      ptPlace: function() {
        let pTplaceFromLS = localStorage.getItem('ptPlace')
        let checkLSLength = pTplaceFromLS.length > 0

        return checkLSLength ? pTplaceFromLS : 'undefined'
      },
      fromCompleted: function() {
        return localStorage.getItem('from_where')
      },
      bsa: function() {
        let surfaceArea = (this.heightValue * this.weightValue) / 3600
        let bsa = Math.sqrt(surfaceArea)
        let bsaNew = Math.round(bsa)
        return bsaNew === 0 ? null : Number(bsaNew)
      },
      bmi: function() {
        let heightInMts = this.heightValue / 100
        let heightSquare = heightInMts * heightInMts
        let bmi = this.weightValue / heightSquare
        return Number(bmi).toFixed(2)
      }
    }
    // watch: {
    //   bmi: function (){
    //     let surfaceArea = (this.heightValue * this.weightValue)/3600
    //     let bsa = Math.sqrt(surfaceArea)
    //     return bsa
    //   }
    // }
  }

</script>
<style media="screen" scoped>

  .masterPatientData {
    min-height: 100vh;
  }

  .input-group {
    width: 90%;
    margin-top: 2rem;
  }

  #height::after {
    content: '..static/vitals/Height.png';
    position: absolute;
  }

  .sidebar {
    background-color: #383b3f;
    color: #fff;
  }

  .sidebar ul li {
    padding: 1rem;
  }

  .sidebar .active {
    background-color: #f2994a;
  }

  .patient_profile > h4 {
    padding: 10px 10px 2px 10px;
  }

  .patient_profile > h5 {
    padding: 0 10px 10px;
  }

  input {
    width: 100% !important;
    height: 15vh;
  }

  .el-input--custom .el-input {
    padding-right: 2rem;
  }

  .zen .el-input-group__prepend {
    padding: 0px !important;
    background-color: #fff !important;
  }

  .input-with-select .prepended {
    width: 100px;
    border: 0px;
    padding: 0px !important;
  }

  .input-with-select .el-input {
    padding-right: 0px !important;
  }

  .pefrContainer {
    /* display: grid; */
    /* grid-template-columns: .1fr .1fr .1fr; */
  }

  .bpContainer.md6,
  .pefrContainer.md6 {
    grid-template-columns: 0.2fr 0.2fr 0.2fr;
  }

</style>
<style>

  #question7 {
    margin-right: 3.7rem;
  }

  #question7 label,
  #question11 label,
  #question12 label {
    visibility: hidden;
  }

  .vImg7,
  .vImg11 {
    display: none;
  }

  #question12 .vImg12 {
    display: none;
  }

  #question6 .bpContainer {
    padding-right: 0rem;
    padding-left: 2rem;
  }

  #question7 .questionHolder {
    padding-left: 0rem;
  }

  #question10,
  #question11,
  #question12 {
    max-width: initial;
  }

  .bpContainer input {
    /* display: grid;
      grid-template-columns: .1fr .1fr .1fr; */
    width: 100px;
  }

  .pefrContainer div.el-form-item .el-form-item__content > div,
  .bpContainer div.el-form-item .el-form-item__content > div {
    display: flex;
  }

  /* .pefrContainer div.el-form-item:nth-child(1) .el-form-item__content > div::after,.pefrContainer div.el-form-item:nth-child(2) .el-form-item__content > div::after,
  .bpContainer div.el-form-item:nth-child(1) .el-form-item__content > div::after{
    content:'-';
    margin-left:5px;
    margin-right:5px;
  }

  #question12  .el-form-item__content > div::after,#question7 .el-form-item__content > div::after{
    content:'-';
    margin-left:5px;
    margin-right:5px;

    visibility:hidden;
  } */

  /* .bpContainer .el-input--custom .el-input,
  .bpContainer .el-input--custom label,
  .pefrContainer .el-input--custom .el-input{
    padding:0rem 0rem 0.625rem 2rem;
  } */

  .questionHolder input {
    /* border-bottom: 0.5px;
    border-color: #ECEDED;
    border-top: 0px;
    border-left: 0px;
    border-right: 0px;
    box-shadow: none;
    border-radius: 0px; */
  }

  /* vitalsAndImageContainer
  vitalsImage
  vitalsNotImage */

  .vitalsAndImageContainer {
    align-items: center;
  }

  .vitalsAndImageContainer .vitalsImage {
    flex: 0 1 20% !important;
  }

  .vitalsAndImageContainer .vitalsImage img {
    width: 4rem;
  }

  /* .vitalsImage.vImg6,
  .vitalsImage.vImg10 {
    flex: 1 1 auto !important;
  } */

  #question11 .questionHolder,
  #question12 .questionHolder {
    padding-left: 0rem;
  }

  #vitalsFormPost,
  #vitalsFormUpdate,
  .extendingBGcolor {
    background-color: white;
    padding-bottom: 1rem;
  }

  .extendingBGcolor {
    padding-left: 1rem;
  }
   /* .bpContainer:nth-of-type(11) { */
     /* background-color: red; */
     /* display: none; */
     /* flex-basis: 100%; */
   /* } */
   /* #whateasd {
     flex-basis: 25%;
     display: inline-flex;
   } */
   /* #question10 {
     display: inline-flex;
   }
   #question10 input,
   #question11 input,
   #question12 input {
     width: 75px !important;
   }
   #question10 .el-input,
   #question11 .el-input,
   #question12 .el-input {
     padding-right: 0px !important;
   }
   .vitalsImage.vImg10 {
     margin-left: -10px;
     margin-right: 10px;
   } */

</style>



// WEBPACK FOOTER //
// src/components/vitals.vue